import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "dash" }
const _hoisted_2 = { class: "dash-hero" }
const _hoisted_3 = { class: "dash-hero-text" }
const _hoisted_4 = { class: "dash-eyebrow" }
const _hoisted_5 = { class: "dash-title" }
const _hoisted_6 = { class: "dash-sub" }
const _hoisted_7 = { class: "dash-period" }
const _hoisted_8 = {
  class: "dash-segment",
  role: "group",
  "aria-label": "Période"
}
const _hoisted_9 = ["aria-pressed", "onClick"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "dash-refund-badge" }
const _hoisted_12 = { class: "dash-refund-window" }
const _hoisted_13 = { class: "dash-refund-track" }
const _hoisted_14 = ["aria-hidden"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "dash-range-field" }
const _hoisted_17 = ["max"]
const _hoisted_18 = { class: "dash-range-field" }
const _hoisted_19 = ["min"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 1,
  class: "dash-empty"
}
const _hoisted_22 = {
  key: 0,
  class: "drv-hero"
}
const _hoisted_23 = { class: "rate-card" }
const _hoisted_24 = ["aria-label"]
const _hoisted_25 = { viewBox: "0 0 120 120" }
const _hoisted_26 = { class: "rate-label" }
const _hoisted_27 = { class: "rate-text" }
const _hoisted_28 = { class: "kpi-stack" }
const _hoisted_29 = { class: "kpi-value" }
const _hoisted_30 = { class: "kpi-foot" }
const _hoisted_31 = { class: "kpi-value" }
const _hoisted_32 = { class: "kpi-value" }
const _hoisted_33 = {
  key: 1,
  class: "kpi-grid",
  "aria-label": "Indicateurs clés"
}
const _hoisted_34 = { class: "kpi-value" }
const _hoisted_35 = { class: "kpi-foot" }
const _hoisted_36 = { class: "kpi-value" }
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "kpi-foot" }
const _hoisted_39 = { class: "kpi-value" }
const _hoisted_40 = { class: "kpi-value" }
const _hoisted_41 = { class: "kpi-foot" }
const _hoisted_42 = { class: "dash-section" }
const _hoisted_43 = { class: "status-grid" }
const _hoisted_44 = { class: "status-name" }
const _hoisted_45 = { class: "status-num" }
const _hoisted_46 = { class: "status-share" }
const _hoisted_47 = { class: "dash-panel" }
const _hoisted_48 = { class: "dash-panel-head" }
const _hoisted_49 = { class: "dash-chip" }
const _hoisted_50 = {
  key: 2,
  class: "dash-empty"
}
const _hoisted_51 = { class: "dash-section-head" }
const _hoisted_52 = { class: "dash-section-title" }
const _hoisted_53 = { class: "pay-grid" }
const _hoisted_54 = { class: "pay-head" }
const _hoisted_55 = { class: "pay-icon" }
const _hoisted_56 = { class: "pay-title" }
const _hoisted_57 = { class: "pay-count" }
const _hoisted_58 = { class: "pay-rows" }
const _hoisted_59 = { class: "pay-total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AnimatedNumber = _resolveComponent("AnimatedNumber")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.isDriver ? "Espace livreur" : "Responsable de zone"), 1),
        _createElementVNode("h1", _hoisted_5, "Bonjour" + _toDisplayString(_ctx.firstName ? `, ${_ctx.firstName}` : ""), 1),
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.todayLabel) + " ", 1),
          (_ctx.lastUpdated)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" · Mis à jour à " + _toDisplayString(_ctx.lastUpdated), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodOptions, (option) => {
            return (_openBlock(), _createElementBlock("button", {
              key: option.key,
              type: "button",
              class: _normalizeClass(["dash-segment-btn", { active: _ctx.period === option.key }]),
              "aria-pressed": _ctx.period === option.key,
              onClick: ($event: any) => (_ctx.setPeriod(option.key))
            }, _toDisplayString(option.label), 11, _hoisted_9))
          }), 128))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["ui-icon-btn dash-refresh", { spinning: _ctx.isLoader }]),
          "aria-label": "Actualiser",
          title: "Actualiser",
          disabled: _ctx.isLoader,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshAll && _ctx.refreshAll(...args)))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("i", {
            class: "ph ph-arrows-clockwise",
            "aria-hidden": "true"
          }, null, -1)
        ]), 10, _hoisted_10)
      ])
    ]),
    (_ctx.isDriver && _ctx.refundAlert.count)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/refunds",
          class: "dash-refund-alert",
          role: "alert"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_11, [
              _cache[5] || (_cache[5] = _createElementVNode("i", {
                class: "ph ph-hand-coins",
                "aria-hidden": "true"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.refundAlert.count) + " remboursement" + _toDisplayString(_ctx.refundAlert.count > 1 ? "s" : "") + " " + _toDisplayString(_ctx.refundAlert.count > 1 ? "affectés" : "affecté"), 1)
            ]),
            _createElementVNode("span", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                  return _createElementVNode("span", {
                    key: n,
                    class: "dash-refund-items",
                    "aria-hidden": n === 2
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.refundAlert.items, (item) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: item.id,
                        class: "dash-refund-item"
                      }, [
                        _createElementVNode("b", null, _toDisplayString(item.ref), 1),
                        _createTextVNode(" · " + _toDisplayString(item.receiver), 1),
                        (item.city_name)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" (" + _toDisplayString(item.city_name) + ")", 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createTextVNode(" · " + _toDisplayString(item.amount) + " " + _toDisplayString(_ctx.refundAlert.currency) + " ", 1),
                        (item.scheduled_for)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" · prévu le " + _toDisplayString(_ctx.refundDate(item.scheduled_for)), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (item.status === 'ASSIGNED')
                          ? (_openBlock(), _createElementBlock("em", _hoisted_15, " · à accepter"))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ], 8, _hoisted_14)
                }), 64))
              ])
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("i", {
              class: "ph ph-caret-right dash-refund-go",
              "aria-hidden": "true"
            }, null, -1))
          ]),
          _: 1,
          __: [6]
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "dash-slide" }, {
      default: _withCtx(() => [
        (_ctx.period === 'custom')
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: "dash-range",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.FilterData && _ctx.FilterData(...args)), ["prevent"]))
            }, [
              _createElementVNode("label", _hoisted_16, [
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "Du", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchSDate) = $event)),
                  type: "date",
                  class: "form-control",
                  max: _ctx.searchEDate || undefined,
                  required: ""
                }, null, 8, _hoisted_17), [
                  [_vModelText, _ctx.searchSDate]
                ])
              ]),
              _createElementVNode("label", _hoisted_18, [
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "Au", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchEDate) = $event)),
                  type: "date",
                  class: "form-control",
                  min: _ctx.searchSDate || undefined,
                  required: ""
                }, null, 8, _hoisted_19), [
                  [_vModelText, _ctx.searchEDate]
                ])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                disabled: _ctx.isLoader
              }, "Appliquer", 8, _hoisted_20)
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.loadError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[9] || (_cache[9] = [
          _createElementVNode("i", {
            class: "ph ph-cloud-slash",
            "aria-hidden": "true"
          }, null, -1),
          _createElementVNode("p", null, "Aucune donnée disponible.", -1)
        ])))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.isDriver)
            ? (_openBlock(), _createElementBlock("section", _hoisted_22, [
                _createElementVNode("article", _hoisted_23, [
                  _createElementVNode("div", {
                    class: "rate-ring",
                    role: "img",
                    "aria-label": `Taux de livraison ${_ctx.rate}%`
                  }, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_25, [
                      _cache[10] || (_cache[10] = _createElementVNode("circle", {
                        class: "rate-track",
                        cx: "60",
                        cy: "60",
                        r: "50"
                      }, null, -1)),
                      _createElementVNode("circle", {
                        class: "rate-value",
                        cx: "60",
                        cy: "60",
                        r: "50",
                        style: _normalizeStyle({ strokeDashoffset: _ctx.ringOffset })
                      }, null, 4)
                    ])),
                    _createElementVNode("span", _hoisted_26, [
                      _createElementVNode("b", null, [
                        _createVNode(_component_AnimatedNumber, { value: _ctx.rate }, null, 8, ["value"]),
                        _cache[11] || (_cache[11] = _createElementVNode("small", null, "%", -1))
                      ]),
                      _cache[12] || (_cache[12] = _createElementVNode("span", null, "livrés", -1))
                    ])
                  ], 8, _hoisted_24),
                  _createElementVNode("div", _hoisted_27, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "kpi-label" }, "Votre taux de livraison", -1)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.rateMessage), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("article", {
                    class: _normalizeClass(["kpi", { 'is-loading': _ctx.isLoader }])
                  }, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "kpi-top" }, [
                      _createElementVNode("span", { class: "kpi-label" }, "Total colis"),
                      _createElementVNode("span", { class: "kpi-icon" }, [
                        _createElementVNode("i", {
                          class: "ph ph-package",
                          "aria-hidden": "true"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_AnimatedNumber, {
                        value: _ctx.num(_ctx.dashData.totalParcels)
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.periodLabel), 1)
                  ], 2),
                  _createElementVNode("article", {
                    class: _normalizeClass(["kpi kpi-success", { 'is-loading': _ctx.isLoader }])
                  }, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "kpi-top" }, [
                      _createElementVNode("span", { class: "kpi-label" }, "Colis livrés"),
                      _createElementVNode("span", { class: "kpi-icon" }, [
                        _createElementVNode("i", {
                          class: "ph ph-check-circle",
                          "aria-hidden": "true"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_AnimatedNumber, {
                        value: _ctx.num(_ctx.dashData.totalParcels_livred)
                      }, null, 8, ["value"])
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "kpi-foot" }, "Livraisons réussies", -1))
                  ], 2),
                  _createElementVNode("article", {
                    class: _normalizeClass(["kpi kpi-warning", { 'is-loading': _ctx.isLoader }])
                  }, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "kpi-top" }, [
                      _createElementVNode("span", { class: "kpi-label" }, "Reportés aujourd'hui"),
                      _createElementVNode("span", { class: "kpi-icon" }, [
                        _createElementVNode("i", {
                          class: "ph ph-clock-countdown",
                          "aria-hidden": "true"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_AnimatedNumber, {
                        value: _ctx.num(_ctx.dashData.POSTPONED)
                      }, null, 8, ["value"])
                    ]),
                    _cache[18] || (_cache[18] = _createElementVNode("p", { class: "kpi-foot" }, "À reprogrammer", -1))
                  ], 2)
                ])
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_33, [
                _createElementVNode("article", {
                  class: _normalizeClass(["kpi kpi-featured", { 'is-loading': _ctx.isLoader }])
                }, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "kpi-top" }, [
                    _createElementVNode("span", { class: "kpi-label" }, "Total colis"),
                    _createElementVNode("span", { class: "kpi-icon" }, [
                      _createElementVNode("i", {
                        class: "ph ph-package",
                        "aria-hidden": "true"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_AnimatedNumber, {
                      value: _ctx.num(_ctx.dashData.totalParcels)
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.periodLabel), 1)
                ], 2),
                _createElementVNode("article", {
                  class: _normalizeClass(["kpi kpi-success", { 'is-loading': _ctx.isLoader }])
                }, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "kpi-top" }, [
                    _createElementVNode("span", { class: "kpi-label" }, "Livrés"),
                    _createElementVNode("span", { class: "kpi-icon" }, [
                      _createElementVNode("i", {
                        class: "ph ph-check-circle",
                        "aria-hidden": "true"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_AnimatedNumber, {
                      value: _ctx.statusNum('DELIVERED')
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", {
                    class: "kpi-progress",
                    title: `Taux de livraison ${_ctx.zoneRate}%`
                  }, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ width: _ctx.zoneRate + '%' })
                    }, null, 4)
                  ], 8, _hoisted_37),
                  _createElementVNode("p", _hoisted_38, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.zoneRate) + "%", 1),
                    _cache[20] || (_cache[20] = _createTextVNode(" taux de livraison", -1))
                  ])
                ], 2),
                _createElementVNode("article", {
                  class: _normalizeClass(["kpi kpi-info", { 'is-loading': _ctx.isLoader }])
                }, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "kpi-top" }, [
                    _createElementVNode("span", { class: "kpi-label" }, "En cours"),
                    _createElementVNode("span", { class: "kpi-icon" }, [
                      _createElementVNode("i", {
                        class: "ph ph-truck",
                        "aria-hidden": "true"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_AnimatedNumber, {
                      value: _ctx.statusNum('IN_PROGRESS') + _ctx.statusNum('DISTRIBUTION')
                    }, null, 8, ["value"])
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("p", { class: "kpi-foot" }, "En cours et en distribution", -1))
                ], 2),
                _createElementVNode("article", {
                  class: _normalizeClass(["kpi kpi-danger", { 'is-loading': _ctx.isLoader }])
                }, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "kpi-top" }, [
                    _createElementVNode("span", { class: "kpi-label" }, "Retournés et refusés"),
                    _createElementVNode("span", { class: "kpi-icon" }, [
                      _createElementVNode("i", {
                        class: "ph ph-arrow-u-up-left",
                        "aria-hidden": "true"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_AnimatedNumber, {
                      value: _ctx.statusNum('RETURNED') + _ctx.statusNum('REFUSE')
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.fmt(_ctx.statusNum("RETURNED"))) + " retournés · " + _toDisplayString(_ctx.fmt(_ctx.statusNum("REFUSE"))) + " refusés", 1)
                ], 2)
              ])),
          _createElementVNode("section", _hoisted_42, [
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "dash-section-head" }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", { class: "dash-eyebrow" }, "Suivi"),
                _createElementVNode("h2", { class: "dash-section-title" }, "Colis par statut")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_43, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: status.key,
                  class: "status-tile",
                  style: _normalizeStyle({ '--st': status.color })
                }, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", {
                    class: "status-bar",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_44, _toDisplayString(status.name), 1),
                  _createElementVNode("span", _hoisted_45, [
                    _createVNode(_component_AnimatedNumber, {
                      value: status.num
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("span", _hoisted_46, _toDisplayString(status.share) + "% du total", 1)
                ], 4))
              }), 128))
            ])
          ]),
          _createElementVNode("section", _hoisted_47, [
            _createElementVNode("header", _hoisted_48, [
              _cache[27] || (_cache[27] = _createElementVNode("div", null, [
                _createElementVNode("span", { class: "dash-eyebrow" }, "Tendance"),
                _createElementVNode("h3", { class: "dash-panel-title" }, "Évolution des colis"),
                _createElementVNode("p", { class: "dash-panel-sub" }, "9 derniers jours")
              ], -1)),
              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.fmt(_ctx.trendTotal)) + " colis", 1)
            ]),
            (_ctx.hasTrend)
              ? (_openBlock(), _createBlock(_component_apexchart, {
                  key: 0,
                  type: "area",
                  height: "260",
                  options: _ctx.trendOptions,
                  series: _ctx.trendSeries
                }, null, 8, ["options", "series"]))
              : (_ctx.isLoader)
                ? (_openBlock(), _createBlock(_component_AppLoader, {
                    key: 1,
                    label: "Chargement de la tendance…"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_50, _cache[28] || (_cache[28] = [
                    _createElementVNode("p", null, "Aucune donnée de tendance.", -1)
                  ])))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentGroups, (group) => {
            return (_openBlock(), _createElementBlock("section", {
              key: group.title,
              class: "dash-section"
            }, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", null, [
                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "dash-eyebrow" }, "Paiements", -1)),
                  _createElementVNode("h2", _hoisted_52, _toDisplayString(group.title), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.cards, (card) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: card.title,
                    class: _normalizeClass(["pay-card", `tone-${card.tone}`])
                  }, [
                    _createElementVNode("header", _hoisted_54, [
                      _createElementVNode("span", _hoisted_55, [
                        _createElementVNode("i", {
                          class: _normalizeClass(card.icon),
                          "aria-hidden": "true"
                        }, null, 2)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_56, _toDisplayString(card.title), 1),
                        _createElementVNode("span", _hoisted_57, [
                          _createVNode(_component_AnimatedNumber, {
                            value: _ctx.num(card.notes)
                          }, null, 8, ["value"]),
                          _cache[30] || (_cache[30] = _createTextVNode(" bons", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("dl", _hoisted_58, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.rows, (row) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: row.label
                        }, [
                          _createElementVNode("dt", null, _toDisplayString(row.label), 1),
                          _createElementVNode("dd", null, _toDisplayString(row.unit === "colis" ? `${_ctx.fmt(row.value)} colis` : `${_ctx.money(row.value)} ${_ctx.devise}`), 1)
                        ], 64))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _cache[31] || (_cache[31] = _createElementVNode("span", null, "Total", -1)),
                      _createElementVNode("b", null, [
                        _createTextVNode(_toDisplayString(_ctx.money(card.total)) + " ", 1),
                        _createElementVNode("small", null, _toDisplayString(_ctx.devise), 1)
                      ])
                    ])
                  ], 2))
                }), 128))
              ])
            ]))
          }), 128))
        ], 64))
  ]))
}